const compareLocationNames = (a, b) =>
    (a.name || '').localeCompare(b.name || '', undefined, {
        numeric: true,
        sensitivity: 'base'
    })

export function sortAvailableDevicesTree(tree) {
    if (!tree || !Array.isArray(tree.children)) return tree

    return {
        ...tree,
        children: [...tree.children].sort(compareLocationNames)
    }
}
